// src/api/index.js
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

// Deacon: same-origin /api/cre through the SWA Function (or setupProxy.js in dev).
// No Beacon credentials or browser-to-App-Service transport.
const api = createAppTransport({ axios, appName: 'cre' });

// CRE-specific API endpoints

export const fetchCRELoans = (before) =>
  api.get(`/cre-entries?before=${encodeURIComponent(before)}`);

export const saveCRELoan = (loans) =>
  api.post('/save-cre', loans);

// ClearWater uses a business ASOFDT, not the loan's UTC timestamp cutoff.
export const fetchEnrichmentData = (modified_date) =>
  api.get(`/enrichment-data?modified_date=${modified_date}`);

export const refreshCache = (reload = true) =>
  api.post('/refresh-cache', { reload });

export const getFieldChoices = (field, parent_value = null) => {
  const params = new URLSearchParams({ field });
  if (parent_value) {
    params.append('parent_value', parent_value);
  }
  return api.get(`/field-choices?${params.toString()}`);
};

export const fetchEntryHistory = (cusip) =>
  api.get(`/entry-history?cusip=${encodeURIComponent(cusip)}`);

export const lookupZipCode = (zipcode) =>
  api.get(`/zip-lookup?zipcode=${encodeURIComponent(zipcode)}`);

export const fetchDealTeamSources = () =>
  api.get('/deal-team-sources');

export const fetchDealTeamEntries = (source, limit = 5000) =>
  api.get(`/deal-team-entries?source=${encodeURIComponent(source)}&limit=${limit}`);

export const fetchDealTeamHistory = (source, key, limit = 5000) =>
  api.get(
    `/deal-team-history?source=${encodeURIComponent(source)}` +
    `&key=${encodeURIComponent(key)}&limit=${limit}`
  );

// The backend reports every deal-team source as read-only and returns 503 on
// /save-deal-team until the CRE schema and its other direct writers are safely
// migrated to the checked writer. Kept only as a request wrapper, never called
// by the read-only workspace.
export const saveDealTeamEntries = (source, rows) =>
  api.post('/save-deal-team', { source, rows });

export { api };
export default api;
